import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import { Colors } from "../theme";

export const BannerVideoAboutUs = styled("video")(({ src, theme }) => ({
  src: `url(${src})`,
  width: "100%",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    margin: "2%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    margin: "2%",
  },
}));

export const InfoCompanyContainerAboutUs = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  margin: "2%",
  width: "92%",
  justifyContent: "center",
  alignItems: "center",
  padding: "2px 8px",
}));

export const InfoCompanyContentAboutUs = styled(Box)(({ theme }) => ({
  display: "flex",
  margin: "2%",
  width: "92%",
  justifyContent: "center",
  alignItems: "center",
  padding: "2px 8px",
  [theme.breakpoints.down("md")]: {
    margin: "2%",
    flexDirection: "column",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "2%",
  },
}));

export const DivisionImageAboutUs = styled("img")(({ src, theme }) => ({
  src: `url(${src})`,
  width: "420px",
  height: "400px",
  boxShadow:
    "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
  margin: "2%",
  [theme.breakpoints.down("md")]: {
    margin: "2%",
    width: "320px",
    height: "300px",
    boxShadow:
      "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "2%",
    width: "220px",
    height: "200px",
    boxShadow:
      "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
  },
}));
